// extracted by mini-css-extract-plugin
export default {"unsaved-warning":"Ojvo324NwPryBWztrPjo"};